import { ReactSVG } from 'react-svg'
import { cn } from '../@/lib/utils'

interface DossIconProps {
  name: string
  size: number
  color?: string
  className?: string
}

/**
 * Renders an icon
 */
export function DossIcon({ name, size, color, className }: DossIconProps) {
  return (
    <div
      className={cn('flex items-center flex-shrink-0', className)}
      style={{ height: size, width: size }}
    >
      <ReactSVG
        beforeInjection={(svg) => {
          if (color) {
            svg.setAttribute('style', `fill: ${color}`)
          }
        }}
        className="size-full"
        src={`/assets/doss-icons/${name}`}
        title={name}
      />
    </div>
  )
}
